/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import { CalculatedMeasure } from 'cio/utils/metrics/measure';

interface ProgressBarArgs {
  progress: CalculatedMeasure['allTimeRate'];
  fillColorClass?: string;
}

export default class ProgressBar extends Component<ProgressBarArgs> {
  get fillColorClass() {
    return this.args.fillColorClass ?? 'bg-success';
  }

  get completedStyle() {
    let completedWidth = 100 * Number(this.args.progress ?? 0);
    return htmlSafe(`height: 100%; width: ${completedWidth}%;`);
  }
}
